module.exports = __webpack_public_path__ + "static/media/ticket-on-mtn.36f3d143.svg";